import * as React from 'react';
import { ProgressBar } from '.';
export const StepProgressBar = ({ currentStep, totalSteps }) => {
    const percentageProgress = (currentStep / totalSteps) * 100;
    return (React.createElement(ProgressBar, { percentageProgress: percentageProgress, screenReaderText: `Step ${currentStep} of ${totalSteps}` }));
};
